<template>
<div>
  <div class="row">
    <div class="col">
      <b-form-group id="occupationPickerGroup" label="Select an Occupation Type" label-for="accountPicker">
        <b-form-input id="occupationPicker" type="text" v-model="occupationInput" placeholder="Enter occupation" @input="onChange" />
        <div class="row m-1 p-2 suggested-account" v-for="occupation in this.filteredOccupations" :key="occupation.id">
          <div class="col-10"  v-on:click="(e) => { occupationSelected(e, occupation) }">
            {{ occupation.title }}
          </div>
        </div>
      </b-form-group>
    </div>
  </div>
</div>
</template>

<script>
import API from '../../api/jobBoard'

export default {
  name: 'occupation-picker',
  props: ['occupationID'],
  data: function () {
    return {
      occupationInput: '',
      filteredOccupations: [],
      selectedOccupation: null,
      selectedOccupationID: ''
    }
  },
  watch: {
    occupationID: function (newVal, oldVal) {
      if (newVal === null) {
        this.selectedOccupation = null
        this.selectedOccupationID = ''
        this.occupationInput = ''
      }
    }
  },
  mounted: function () {
    if (this.occupationID !== '') {
      API.getJobBoardOccupation(this.occupationID).then(
        response => {
          if (response.data.success) {
            this.selectedOccupation = response.data.results
            this.occupationInput = this.selectedOccupation.title
            this.selectedOccupationID = this.selectedOccupation.id
          }
        }
      )
    }
  },
  methods: {
    onChange () {
      //  start making suggestions after more than two characters have been entered.
      if (this.occupationInput.length < 2) {
        return
      }
      API.searchForJobBoardOccupation(this.occupationInput).then(
        response => {
          this.filteredOccupations = response.data.results
        }
      )
    },
    occupationSelected (e, occupation) {
      e.preventDefault()
      this.mountAccount(occupation)
    },
    mountAccount (occupation) {
      this.filteredOccupations = []
      this.$emit('selectedOccupation', occupation)
      this.occupationInput = occupation.title
    }
  }
}
</script>

<style scoped>
.suggested-account {
  border: solid 1px #eee;
  cursor: pointer;
}
.suggested-account:hover {
  background: #eee;
}
.employer {
  font-weight: 300;
}
</style>



// WEBPACK FOOTER //
// src/components/jobBoard/OccupationSearch.vue